import { DETERMINAR_PAGINA_ATUAL_MDFE } from '../types'

export default function determinarPaginaAtualMdfe(pagina) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_MDFE,
    payload: pagina
  }
}
